import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class FinancialItemChargeModal extends BaseModel {
  amount = '';
  taxable = false;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    amount: 'required'
  };

  attributeHints = {
    amount: i18n.t('Amount'),
    taxable: i18n.t('Taxable'),
  };

  attributeLabels = {
    amount: i18n.t('Amount'),
    taxable: i18n.t('Taxable'),
  };
}
